import _c from "../CodeSkeleton/CodeSkeleton.module.css";
import React, {Fragment} from "react";

const ReactTopShell = () => {
    return <Fragment>
        <span><span className={_c.orange}>import</span> React <span className={_c.orange}>from </span><span className={_c.text}>{"\"react\""}</span><span className={_c.orange}>;</span></span>
        <span><span className={_c.orange}>import</span> GraphX <span className={_c.orange}>from </span><span className={_c.text}>{"\"boxparade-graphx-react\""}</span><span className={_c.orange}>;</span></span><br/>
        <span><span className={_c.orange}>const</span> <span className={_c.gold}>GraphXPage</span>{" = () => {"}<br/></span>
        <span className={_c.indent1}><span className={_c.orange}>const</span> {"pieJson = {"}</span></Fragment>
};

export default ReactTopShell;